import '../../styles/Auth.css';

import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {signInWithEmailAndPassword} from 'firebase/auth';
import {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';

import {auth} from '../../firebase';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Sign in with Firebase Authentication
      await signInWithEmailAndPassword(auth, email, password);

      // Successfully logged in
      // Redirect to dashboard
      navigate('/dashboard');
    } catch (error) {
      setError(getErrorMessage(error.code));
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get user-friendly error messages
  const getErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 'auth/invalid-email':
        return 'Invalid email address format.';
      case 'auth/user-disabled':
        return 'This account has been disabled.';
      case 'auth/user-not-found':
        return 'No account found with this email.';
      case 'auth/wrong-password':
        return 'Incorrect password.';
      case 'auth/too-many-requests':
        return 'Too many failed login attempts. Please try again later.';
      default:
        return 'An error occurred during login. Please try again.';
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className='auth-container'>
      <div className='auth-card'>
        <h2>Welcome to Tenvos</h2>

        {error && <div className='auth-error'>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              id='email'
              placeholder='Your email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className='form-group'>
            <label htmlFor='password'>Password</label>
            <div className='password-input-container'>
              <input
                type={showPassword ? 'text' : 'password'}
                id='password'
                placeholder='Your password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
              <button
                type='button'
                className='password-toggle-btn'
                onClick={togglePasswordVisibility}
                tabIndex='-1'
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          <button type='submit' className='auth-button' disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className='auth-links'>
          <Link to='/forgot-password' className='auth-link'>
            Forgot password?
          </Link>
          <Link to='/signup' className='auth-link'>
            Need an account? Sign up
          </Link>
          {/* <Link to="/privacy" className="auth-link">Privacy</Link> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
